"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-alert,react/jsx-indent */
const params_1 = require("use-query-params/lib/params");
// eslint-disable-next-line no-use-before-define
const react_1 = __importStar(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const use_query_params_1 = require("use-query-params");
const core_1 = require("@material-ui/core");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ActionButtons_1 = __importDefault(require("coact/pages/modules/pageAction/ActionButtons"));
const moment_1 = __importDefault(require("moment"));
const react_router_1 = require("react-router");
const AssertInfoDownloaderView_1 = __importDefault(require("./Downloader/AssertInfoDownloaderView"));
const AssertionInfoStatus_1 = require("../../assertion/AssertionInfoStatus");
const DataTableView_1 = __importDefault(require("../../ui/DataTableView"));
const utils_1 = require("../utils");
const PagedDataTableView_1 = __importDefault(require("./PagedDataTableView"));
const DataTableField_1 = require("../../stockRecordWorkflow/ui/DataTableField");
const SUBMIT_ASSERTION_INFO = graphql_tag_1.default `
  mutation submitAssertionInfo($id: String!) {
    submitAssertionInfo(id: $id)
  }
`;
const DELETE_ASSERTION_INFO = graphql_tag_1.default `
  mutation deleteAssertionInfo($id: String!) {
    deleteAssertionInfo(id: $id)
  }
`;
const RESET_INVENTORY_INFOS = graphql_tag_1.default `
  mutation resetAssertionInfo($id: String!) {
    resetAssertionInfo(id: $id) {
      id
    }
  }
`;
const CONFIRM_ASSERTION_INFO = graphql_tag_1.default `
  mutation confirmAssertionInfo($id: String!) {
    confirmAssertionInfo(id: $id) {
      id
      status
    }
  }
`;
const GET_ASSERTION_INVENTORY = graphql_tag_1.default `
  query getAssertionInventoryItems($assertionInfoId: String!, $offset: Int!, $limit: Int!, $onlyShowDiff: Boolean!) {
    getAssertionInventoryItems(assertionInfoId: $assertionInfoId, offset: $offset, limit: $limit, onlyShowDiff: $onlyShowDiff) {
      id
      stockInfo {
        _id
        stock {
          product {
            key
            name
          }
        }
      }
      qty
      projectedQty
      averageCost
    }
    getAssertionInfo(id: $assertionInfoId) {
      id
      status
      warehouse {
        name
      }
      assertedCost
      assertedQty
      projectedCost
      projectedQty
      startDate
      submitDate
    }
  }
`;
const INCREMENT_ASSERTION_INVENTORY_ITEM_QTY = graphql_tag_1.default `
  mutation ($assertionInfoId: String!, $barcode: String!) {
    incrementAssertionInventoryItemQty(assertionInfoId: $assertionInfoId, barcode: $barcode) {
      id
      projectedQty
      averageCost
      qty
      updatedAt
    }
  }
`;
const UPDATE_INVENTORY_QTY = graphql_tag_1.default `
  mutation updateAssertionInventoryItemQty($id: String!, $qty: Int!) {
    updateAssertionInventoryItemQty(id: $id, qty: $qty) {
      id
      qty
    }
  }
`;
// eslint-disable-next-line no-unused-vars
function TextFieldOnEnter({ onFinished }) {
    const [value, setValue] = react_1.useState('');
    return (react_1.default.createElement(core_1.TextField, { id: "productBarCode", label: "\u5546\u54C1\u689D\u78BC", value: value, onKeyDown: (e) => {
            if (e.keyCode === 13) {
                onFinished(value);
                setValue('');
            }
        }, onChange: (e) => {
            setValue(e.target.value);
        } }));
}
function DoAssertionView(props) {
    const queryParamsConfig = {
        pageNum: params_1.NumberParam,
        pageLimit: params_1.NumberParam,
        onlyShowDiff: params_1.BooleanParam,
    };
    const assertionInfoId = props.match.params.id;
    const [productBarCode, setProductBarCode] = react_1.useState('');
    const [lastProductBarCode, setLastProductBarCode] = react_1.useState('');
    const inputRef = react_1.useRef(null);
    const [resetAssertionInfo] = react_hooks_1.useMutation(RESET_INVENTORY_INFOS);
    const [incrementAssertionInventoryItemQty] = react_hooks_1.useMutation(INCREMENT_ASSERTION_INVENTORY_ITEM_QTY);
    const [updateInventoryQty] = react_hooks_1.useMutation(UPDATE_INVENTORY_QTY);
    const [submitAssertionInfo] = react_hooks_1.useMutation(SUBMIT_ASSERTION_INFO);
    const [deleteAssertionInfo] = react_hooks_1.useMutation(DELETE_ASSERTION_INFO);
    const [confirmAssertionInfo, { loading }] = react_hooks_1.useMutation(CONFIRM_ASSERTION_INFO);
    const [query, setQuery] = use_query_params_1.useQueryParams(queryParamsConfig);
    const { pageNum = 1, pageLimit = 10, onlyShowDiff = false, } = query;
    react_1.useEffect(() => {
        if (inputRef != null && inputRef.current != null)
            inputRef.current.focus();
    }, [lastProductBarCode, pageNum, onlyShowDiff]);
    const { loading: isLoading, data: rawData } = react_hooks_1.useQuery(GET_ASSERTION_INVENTORY, {
        variables: {
            assertionInfoId: props.match.params.id,
            offset: (pageNum - 1) * pageLimit,
            limit: pageLimit,
            onlyShowDiff,
        },
    });
    if (rawData !== undefined
        && (rawData.getAssertionInfo.status === AssertionInfoStatus_1.AssertionInfoStatus.Deleted
            || rawData.getAssertionInfo.status === AssertionInfoStatus_1.AssertionInfoStatus.Cancelled)) {
        return react_1.default.createElement(react_router_1.Redirect, { to: "/assertManagement" });
    }
    if (loading) {
        return react_1.default.createElement(core_1.CircularProgress, null);
    }
    const setPageNum = (value) => {
        setQuery({ pageNum: value });
    };
    const setPageLimit = (value) => {
        setQuery({ pageLimit: value });
    };
    const setOnlyShowDiff = (value) => {
        setQuery({ onlyShowDiff: value });
    };
    // TO_IMPROVE
    const refetchFirstPageAll = {
        query: GET_ASSERTION_INVENTORY,
        variables: {
            assertionInfoId: props.match.params.id,
            offset: (pageNum - 1) * pageLimit,
            limit: pageLimit,
            onlyShowDiff: false,
        },
    };
    const refetchCurrentPageAll = {
        query: GET_ASSERTION_INVENTORY,
        variables: {
            assertionInfoId: props.match.params.id,
            offset: 0,
            limit: pageLimit,
            onlyShowDiff: false,
        },
    };
    const refetchFirstPageOnlyShowDiff = {
        query: GET_ASSERTION_INVENTORY,
        variables: {
            assertionInfoId: props.match.params.id,
            offset: (pageNum - 1) * pageLimit,
            limit: pageLimit,
            onlyShowDiff: true,
        },
    };
    const refetchCurrentPageOnlyShowDiff = {
        query: GET_ASSERTION_INVENTORY,
        variables: {
            assertionInfoId: props.match.params.id,
            offset: 0,
            limit: pageLimit,
            onlyShowDiff: true,
        },
    };
    const refetchQueries = pageNum === 1
        ? [refetchFirstPageAll, refetchFirstPageOnlyShowDiff]
        : [refetchFirstPageAll, refetchFirstPageOnlyShowDiff,
            refetchCurrentPageAll, refetchCurrentPageOnlyShowDiff];
    const onMouseUp = rawData !== undefined && (rawData.getAssertionInfo.status === AssertionInfoStatus_1.AssertionInfoStatus.Asserting ? (index) => {
        const item = rawData.getAssertionInventoryItems[index];
        const productKey = item.stockInfo.stock.product.key;
        const input = window.prompt(`[${productKey}] ${item.stockInfo.stock.product.name} 庫存數量: `, item.qty.toString());
        if (input == null)
            return;
        // eslint-disable-next-line consistent-return
        return updateInventoryQty({
            variables: {
                id: item.id,
                qty: parseInt(input, 10),
            },
            refetchQueries,
        }).catch((err) => {
            const audio = new Audio('/alarm.m4a');
            return audio.play().then(() => {
                if (err.networkError) {
                    alert('網路連線錯誤，請檢查一下您的網路狀況');
                }
                else {
                    alert(`發生錯誤，請聯絡資訊人員: ${err}`);
                }
            });
        });
    } : () => {
    });
    const statusHeader = {
        getUniqueId() {
            return '0';
        },
        getStyle() {
            return {};
        },
    };
    const statusFields = [
        {
            label: '盤點單位',
            width: 200,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(data) {
                return data.warehouse.name;
            },
        },
    ];
    if (props.canDisplayCost) {
        statusFields.push({
            label: '已盤數量',
            width: 200,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(data) {
                if (data.assertedQty == null) {
                    return '(N/A)';
                }
                return data.assertedQty.toString();
            },
        }, {
            label: '已盤金額',
            width: 200,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(data) {
                if (data.assertedCost == null) {
                    return '(N/A)';
                }
                return data.assertedCost.toFixed(2);
            },
        }, {
            label: '盤差數量',
            width: 200,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(data) {
                if (data.assertedQty == null || data.projectedQty == null) {
                    return '(N/A)';
                }
                return (data.projectedQty - data.assertedQty).toString();
            },
        }, {
            label: '盤差金額',
            width: 200,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(data) {
                if (data.projectedCost == null) {
                    return '(N/A)';
                }
                return (data.projectedCost - data.assertedCost).toFixed(2);
            },
        }, {
            label: '應盤金額',
            width: 200,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(data) {
                if (data.projectedCost == null) {
                    return '(N/A)';
                }
                return data.projectedCost.toFixed(2);
            },
        });
    }
    statusFields.push({
        label: '開始時間',
        width: 100,
        textAlign: DataTableField_1.TextAlignment.Left,
        toFormat(data) {
            if (data.startDate == null)
                return '(N/A)';
            return moment_1.default(data.startDate).format('YYYY/MM/DD');
        },
    }, {
        label: '結束時間',
        width: 100,
        textAlign: DataTableField_1.TextAlignment.Left,
        toFormat(data) {
            if (data.submitDate == null)
                return '尚未結束';
            return moment_1.default(data.submitDate).format('YYYY/MM/DD');
        },
    });
    const header = {
        getUniqueId(r) {
            return r.item.id;
        },
        getStyle(r) {
            const lastProductKey = utils_1.getProductKey(lastProductBarCode);
            if (r.item.stockInfo == null)
                return {};
            if (r.item.stockInfo.stock.product.key === lastProductKey)
                return { backgroundColor: 'rgba(255, 100, 100, 0.1)' };
            return {};
        },
    };
    const fields = [
        {
            label: '筆',
            width: 40,
            textAlign: DataTableField_1.TextAlignment.Center,
            toFormat(data) {
                return (data.i + (pageNum - 1) * pageLimit + 1).toString();
            },
        },
        {
            label: '商品編號',
            width: 200,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(data) {
                const stockInfo = data.item.stockInfo;
                if (stockInfo == null) {
                    return '(N/A)';
                }
                return stockInfo.stock.product.key;
            },
        },
        {
            label: '商品名稱',
            width: 500,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(data) {
                const stockInfo = data.item.stockInfo;
                if (stockInfo == null) {
                    return '(N/A)';
                }
                return stockInfo.stock.product.name;
            },
        },
        {
            label: '已點數量',
            width: 100,
            textAlign: DataTableField_1.TextAlignment.Right,
            toFormat(data) {
                return data.item.qty.toString();
            },
        },
        {
            label: '預期數量',
            width: 100,
            textAlign: DataTableField_1.TextAlignment.Right,
            toFormat(data) {
                if (data.item.projectedQty == null)
                    return 'N/A';
                return data.item.projectedQty.toString();
            },
        },
        {
            label: '盤差',
            width: 100,
            textAlign: DataTableField_1.TextAlignment.Right,
            toFormat(data) {
                return (data.item.qty - data.item.projectedQty).toString();
            },
        },
    ];
    if (props.canDisplayCost) {
        fields.push({
            label: '平均成本',
            width: 100,
            textAlign: DataTableField_1.TextAlignment.Right,
            toFormat(data) {
                if (data.item.averageCost == null)
                    return 'N/A';
                return data.item.averageCost.toString();
            },
        });
    }
    const submitAction = {
        text: '送出盤點結果',
        props: {},
        onClick: () => __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-restricted-globals
            if (window.confirm('確定盤點已經完成可以送出 ?')) {
                yield submitAssertionInfo({
                    variables: {
                        id: assertionInfoId,
                    },
                    refetchQueries,
                });
            }
        }),
    };
    const printAction = {
        text: '從 POS 印出盤點報表',
        props: {},
        onClick: () => __awaiter(this, void 0, void 0, function* () {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(rawData.getAssertionInventoryItems.map(e => ({
                    name: e.stockInfo.stock.product.name,
                    amount: e.qty,
                }))),
            };
            yield fetch('http://localhost:3000/printShiftReportsTicket', requestOptions);
        }),
    };
    const deleteAction = {
        text: '刪除盤點',
        props: {},
        onClick: () => __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-restricted-globals
            if (window.confirm('確定要刪除盤點單 ?')) {
                yield deleteAssertionInfo({
                    variables: {
                        id: assertionInfoId,
                    },
                    refetchQueries,
                });
            }
        }),
    };
    const resetAction = {
        text: '重新開始盤點',
        props: {},
        onClick: () => __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-restricted-globals
            if (window.confirm('確定要重新開始 ?')) {
                resetAssertionInfo({
                    variables: {
                        id: assertionInfoId,
                    },
                    refetchQueries,
                }).catch((e) => console.log(e))
                    .then(() => {
                    setLastProductBarCode('');
                    setPageNum(undefined);
                });
            }
        }),
    };
    const assertAction = {
        text: '認列',
        props: {},
        onClick: () => __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-restricted-globals
            if (window.confirm('確定認列盤點結果 ?')) {
                confirmAssertionInfo({
                    variables: {
                        id: assertionInfoId,
                    },
                    refetchQueries,
                }).catch((e) => console.log(e))
                    .then(() => {
                    setPageNum(undefined);
                });
            }
        }),
    };
    let actions = [];
    let queryField = null;
    if (rawData !== undefined) {
        if (rawData.getAssertionInfo.status === AssertionInfoStatus_1.AssertionInfoStatus.Asserting) {
            actions = [submitAction, resetAction, deleteAction, printAction];
            queryField = react_1.default.createElement(TextFieldOnEnter, { onFinished: val => setProductBarCode(val) });
        }
        else if (rawData.getAssertionInfo.status === AssertionInfoStatus_1.AssertionInfoStatus.Submitted) {
            actions = [assertAction, deleteAction];
        }
        else if (rawData.getAssertionInfo.status === AssertionInfoStatus_1.AssertionInfoStatus.Finished) {
            actions = [assertAction, deleteAction];
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("table", null,
            react_1.default.createElement("tbody", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(DataTableView_1.default, { header: statusHeader, fields: statusFields, data: rawData === undefined ? [] : [rawData.getAssertionInfo] })),
                    react_1.default.createElement("td", { style: { verticalAlign: 'top' } },
                        react_1.default.createElement(ActionButtons_1.default, { actions: actions, classes: null }))),
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("form", { onSubmit: (e) => __awaiter(this, void 0, void 0, function* () {
                                const key = utils_1.getProductKey(productBarCode);
                                if (key == null) {
                                    setLastProductBarCode('');
                                }
                                else {
                                    return incrementAssertionInventoryItemQty({
                                        variables: {
                                            assertionInfoId: props.match.params.id,
                                            barcode: productBarCode,
                                        },
                                        refetchQueries,
                                    }).then((result) => {
                                        setLastProductBarCode(productBarCode);
                                        setProductBarCode('');
                                        if (result.data.incrementAssertionInventoryItemQty == null) {
                                            return new Audio('/alarm.m4a').play();
                                        }
                                        return null;
                                    }).catch((err) => {
                                        const audio = new Audio('/error.m4a');
                                        return audio.play().then(() => {
                                            setProductBarCode('');
                                            e.preventDefault();
                                            if (err.networkError) {
                                                alert('網路連線錯誤，請檢查一下您的網路狀況');
                                            }
                                            else {
                                                alert(`找不到商品: ${productBarCode}`);
                                            }
                                        });
                                    });
                                }
                                setProductBarCode('');
                                e.preventDefault();
                            }) },
                            queryField,
                            react_1.default.createElement(core_1.FormControlLabel, { control: (react_1.default.createElement(core_1.Checkbox, { onChange: e => setOnlyShowDiff(e.target.checked), checked: onlyShowDiff })), label: "\u53EA\u986F\u793A\u6709\u76E4\u5DEE\u7684\u5546\u54C1" }),
                            react_1.default.createElement(AssertInfoDownloaderView_1.default, { id: props.match.params.id, canDisplayCost: props.canDisplayCost })))))),
        react_1.default.createElement(PagedDataTableView_1.default, { header: header, fields: fields, data: rawData === undefined ? [] : rawData
                .getAssertionInventoryItems.map((item, i) => ({ item, i })), isLoading: isLoading, pageLimit: pageLimit, pageNum: pageNum, setPageLimit: setPageLimit, setPageNum: setPageNum, onMouseUp: onMouseUp, defaultFilter: "" })));
}
exports.default = DoAssertionView;
